import { render, staticRenderFns } from "./EditClientContactComponent.vue?vue&type=template&id=9d54677e&scoped=true&"
import script from "./EditClientContactComponent.vue?vue&type=script&lang=ts&"
export * from "./EditClientContactComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EditClientContactComponent.vue?vue&type=style&index=0&id=9d54677e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d54677e",
  null
  
)

export default component.exports